import { useCallback } from 'react';
import style from './Blogs.module.css';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import moment from 'moment';
import parse from 'html-react-parser';
import {
	GoogleMap,
	Marker,
	useJsApiLoader
} from "@react-google-maps/api";
import { useLocation } from 'react-router-dom';
import Loading from '../../components/Loading/Loading.jsx';
import NoData from '../../components/NoData/NoData.jsx';
import '../../components/headersStyling.css';
import { useTranslation } from 'react-i18next';
import { host_url, map_key, basename } from "../../configiration/config";
import { getPopularBlogs, getSectionDetails, getBlogDetails } from '../../Api/blogApis';
import location from '../../assets/icons/location.svg';
import share from '../../assets/icons/share.svg';
import noImage from '../../assets/images/noImage.png';
import ShareModal from './../../components/shareModal/shareModal';
import { filterLanguage, filterProperties } from './../../utilities/filterFunction';

function BlogDetails() {
	const { pathname } = useLocation();
    const { slug,section } = useParams();
	const [loading, setLoading] = useState(true);
	const [blog, setBlog] = useState();
	const [blogLocale, setBlogLocale] = useState();
	const [sections, setsections] = useState();
	const [latitude, setLatitude] = useState(25.204849);
	const [longitude, setLongitude] = useState(55.270782);
	const [popularBlogs, setPopularBlogs] = useState();
	const { t, i18n } = useTranslation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	// GoogleMaps Implementation
	function MygoogleMaps() {
		const containerStyle = {
			width: '100%',
			height: '300px'
		};

		const center = {
			lat: Number(latitude),
			lng: Number(longitude)
		};

		const markers = [{
			position: {
				lat: Number(latitude),
				lng: Number(longitude)
			}
		}]

		const { isLoaded = true } = useJsApiLoader({
			id: 'google-map-script',
			googleMapsApiKey: map_key
		})
		//eslint-disable-next-line
		const [map, setMap] = useState(null)

		const onUnmount = useCallback(function callback(map) {
			setMap(null)
		}, [])

		return isLoaded ? (
			<GoogleMap
				mapContainerStyle={containerStyle}
				center={center}
				zoom={16}
				onUnmount={onUnmount}
			>
				<Marker position={markers[0].position} >
				</Marker>
			</GoogleMap>
		) : <></>
	}

	useEffect(() => {
		// get blog detials by slug
		if(slug){
			getBlogDetails(slug).then(response => {
				if (response.data.status === true) {
					let blogLocale={...blog}
					blogLocale=response.data.data
					setBlog(blogLocale)
					setLatitude(Number(response.data.data.latitude))
					setLongitude(Number(response.data.data.longitude))

					let localesAtSelectedLanguage = filterLanguage(blogLocale.locales);
					let lang;
					if (i18n.language === 'en') {
						lang = 'ar';
					} else if (i18n.language === 'ar') {
						lang = 'en';
					}
					let localesAtDifferentLanguage = filterProperties(blogLocale.locales, lang);
					if (localesAtSelectedLanguage.length > 0) {
						setBlogLocale(localesAtSelectedLanguage)
					} else {
						setBlogLocale(localesAtDifferentLanguage)
					}
				}
				setLoading(false);
			})

		}
		getPopularBlogs(slug).then(response => {
			if (response.data.status === true) {
				setPopularBlogs(response.data.data)
			}
		})
			.catch(error => {
				console.log(error)
			});
			setLoading(true);
			//eslint-disable-next-line
	}, [ slug, i18n.language]);

	useEffect(() => {
		if( blog && blog.locales  && blog.locales.length > 0) {
		 const description = document.querySelector("meta[name='description']");
		 description.setAttribute('content', blog.locales[0].meta_description);
		 const keywords = document.querySelector("meta[name='keywords']");
		 keywords.setAttribute('content', blog.locales[0].meta_keywords);
		}
		// get sections detials by slug
		if(section){
			getSectionDetails(section).then(response => {
			if (response.data.status === true) {
				setsections(response.data.data)
			}
		})}
	 },[section,blog])
	//  console.log(blog)
	return (
		<div>
			{/* START OF HEADER sections */}
			<div className={`myHeader d-flex align-items-center justify-content-center`} style={{ backgroundImage: blog && sections ? `url(${host_url}/${blog.blog_section?.image})` : '' }}>
				<div className={`myHeaderContent`}>
					{blog && sections && (
						<>
							<h1>{sections.locales && sections.locales.length >0 && filterLanguage(sections.locales)[0].name}</h1>
							<p>
								<Link className='homeWord'
									to={`${basename}/`}>
									{t('home')}

								</Link>
								/
								<Link className='homeWord'
									to={`${basename}/blogs`}>
									{t('blog')}
								</Link>
								/
								{sections && 
									<>
										<Link className='homeWord'
											to={`${basename}/blogs/${sections.slug}`}>
										{sections.locales && sections.locales.length >0 && filterLanguage(sections.locales)[0].name}
										</Link>
										/ {blogLocale && blogLocale.length > 0 && blogLocale[0].title}
									</>
						}
							</p>
						</>
					)}
				</div>
			</div>
			{/* END OF HEADER sections */}

			<div className={`${style.myCustomContainer} my-5`}>
				{/* START OF DETAILS sections */}

				{/* map modal*/}
				<div className="modal fade" id="locationModal" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="locationModalLabel" aria-hidden="true">
					<div className="modal-dialog modal-dialog-centered modal-lg">
						<div className="modal-content">
							<div className="modal-header border-bottom-0">
								<button type="button" className={`btn-close ${i18n.language === 'ar' ? 'ms-0' : ''}`} data-bs-dismiss="modal" aria-label="Close"></button>
							</div>
							<div className="modal-body">
								{MygoogleMaps()}
							</div>
						</div>
					</div>
				</div>

				{blog && (
					<div className='row'>
						<div className={`${style.articleDetails} col-lg-9`}>
							{/* article img */}
							<div className={`${style.articleImage}`}>
								<img src={`${host_url}/${blog.image}`} alt="mainImage" onError={(e) => { e.target.src = noImage }} />
							</div>

							{/* article title */}
							<div className={`${style.articleTitle} my-4`}>
								<h3>{blogLocale && blogLocale.length >0 && blogLocale[0].title}</h3>
								<div className={`${style.shareButtonsCustom}`}>
									<button type="button" data-bs-toggle="modal" data-bs-target="#locationModal">
										<img src={location} alt='loc' />
										{t('location')}
									</button>

									<button type="button" data-bs-toggle="modal" data-bs-target="#shareModal">
										<img src={share} alt='share' />
										{t('share')}
									</button>
								</div>

								{/* share modal*/}
								<div className="modal fade" id="shareModal" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="locationModalLabel" aria-hidden="true">
									<div className="modal-dialog modal-dialog-centered">
										<div className="modal-content">
											<ShareModal />
										</div>
									</div>
								</div>
							</div>
							{/* article info */}
							<div className={`${style.articleDetailsDesc}`}>
								{blogLocale && blogLocale.length > 0 && parse(blogLocale[0].description)}
							</div>

						</div>

						{/* START OF ASIDE sections */}
						<div className={`${style.aside} col-lg-3`}>
							<aside>
								<h5>{t('popular-blogs')}</h5>
								<div className={`${style.popularPlaces}`}>
									{popularBlogs && popularBlogs.map(popularBlog => {	
										let selectedBlog=filterLanguage(popularBlog.locales)
										let lang;
										if(i18n.language === 'ar'){
											lang = 'en'
										}else if(i18n.language === 'en'){
											lang = 'ar'
										}
										let diferentLanguage = filterProperties(popularBlog.locales,lang)
										return(
										<div key={popularBlog.slug} className={`${style.place} d-flex align-items-start justify-content-start mb-3`} >
											<Link to={`${basename}/blogs/${popularBlog.section.slug}/${popularBlog.slug}`}  state={{blog: popularBlog}} className={`${style.placeImg}`}>
												<img src={`${host_url}/${popularBlog.image}`} alt="popularblog" onError={(e) => { e.target.src = noImage }} />
											</Link>
										<div className={`${style.placeDetails} d-flex flex-column align-items-start justify-content-between`}>
												<Link to={`${basename}/blogs/${popularBlog.section.slug}/${popularBlog.slug}`} state={{blog: popularBlog}} >
													<h6 className={`${style.placeName}`} style={{ textAlign: 'initial' }}>{selectedBlog.length === 0 ? (diferentLanguage[0].title ): selectedBlog[0].title}</h6>
												</Link>
													<span className={`${style.date}`}>{moment(popularBlog.created_at).format('LL')}</span>
										</div>
										</div>
									)}
									)}
								</div>
							</aside>
						</div>
						{/* END OF ASIDE sections */}
					</div>
				)}

				{loading && (
					<Loading width='100px' height='100px' />
				)}

				{!loading && (!blog || !blog) &&
					<NoData text='No available data' />
				}

				{/* END OF DETAILS sections */}
			</div>
		</div>
	)
}

export default BlogDetails